export default __webpack_public_path__ + "img/sun.31402f8c.svg";